import React from 'react'
import { QuestionInputProps } from '../../questionTypes'

export const YesNoQuestion: React.FC<QuestionInputProps> = ({ value, onChange, readOnly = false }) => (
  <div className='survey-response-question__yesno'>
    <button
      type='button'
      className={[
        'survey-response-question__yesno-btn',
        'survey-response-question__yesno-btn--yes',
        value === 'yes' && 'is-active'
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() => onChange('yes')}
      disabled={readOnly}
      aria-label='Yes'
    >
      <svg viewBox='0 0 20 20' fill='currentColor'>
        <path
          fillRule='evenodd'
          d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
          clipRule='evenodd'
        />
      </svg>
      Yes
    </button>
    <button
      type='button'
      className={[
        'survey-response-question__yesno-btn',
        'survey-response-question__yesno-btn--no',
        value === 'no' && 'is-active'
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() => onChange('no')}
      disabled={readOnly}
      aria-label='No'
    >
      <svg viewBox='0 0 20 20' fill='currentColor'>
        <path
          fillRule='evenodd'
          d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
          clipRule='evenodd'
        />
      </svg>
      No
    </button>
  </div>
)
